import { HousingType } from 'interfaces/property'

export const HOUSING_TYPES: HousingType[] = ['rent', 'ownership', 'other']

// pseudo id that means it's new property
// it's used for editId in settings' state
export const NEW_PROPERTY_ID = -1

export const DEFAULT_MEMBER_EMPTY_VALUE = 'Not Provided'
